import type { ReactElement, ReactNode } from 'react';
import { cn } from '../../lib/cn';

export type SubmissionViewShellProps = {
  progressHeader: ReactNode;
  children: ReactNode;
  actionStrip: ReactNode;
  className?: string;
};

/**
 * Submission grading screen shell: progress header, 3-column body, fixed action strip.
 * Uses no-scroll flex column; panes manage their own overflow.
 */
export function SubmissionViewShell({
  progressHeader,
  children,
  actionStrip,
  className,
}: SubmissionViewShellProps): ReactElement {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-1 flex-col overflow-hidden',
        'pb-[max(0.75rem,env(safe-area-inset-bottom))] lg:pb-0',
        className
      )}
      data-dg-submission-view
    >
      <header className="shrink-0 border-b border-dg-border bg-dg-bg-surface/90 px-3 py-2.5 dark:border-slate-700/70 dark:bg-slate-900/40 lg:px-4">
        {progressHeader}
      </header>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
      {actionStrip}
    </div>
  );
}
